import { useMemo } from "react";
import { useTheme } from "../contexts/ThemeContext";
import { createSystemButtonStyles } from "../utils/styles/systemButtonStyles";

/** Shared Mentor List / User Admin button sx tokens for any page */
export function useSystemButtonStyles() {
  const { isDarkMode } = useTheme();
  return useMemo(() => createSystemButtonStyles(isDarkMode), [isDarkMode]);
}
